<template>
  <div class='wrap'>
      <div class="img"></div>
      <p class="msg">页面丢失了，请重新打开或刷新页面</p>
      <el-button class='btn' type="primary" size='small' @click="$router.go(0)" round>刷新</el-button>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='scss' scoped>
  .wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img {
      width: 240px;
      height: 168px;
      background: url('~@/assets/404.png') center / 100% 100%;
    }
    .msg {
      margin-top: 30px;
      font-size: 15px;
      color: #666;
    }
    .btn {
      margin-top: 15px;
      width: 80px;
      background: linear-gradient(to right, #026CFF, #569DFF);
    }
  }
</style>